/* eslint-disable max-len */
/**
 * 弹跳动画
 * 路径 + 滤镜复合动画
 * 路径部分参考文件 @src/js/js-keyframe-animation/style-converter/effects/bounce.ts
 */
import { Canvas, dep, DisplayObject, Filter, getDefaults } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import { AnimFilters, Action } from '../../anim-constants';
import { IAnimFilterOptions } from '../../anim-interface';

const DEFAULT_DURATION = 2000; // 弹跳动画默认时长 2s
const ENTR_FILTER_DURATION = 580; // 入场动画滤镜时长 580ms
const EXIT_FILTER_DURATION = 180; // 退场动画滤镜时长 180ms

export default class BounceFilter extends Filter {
    public static defaults: IAnimFilterOptions = {
        rate: 0,
        direction: PresetSubtype.UnSupport,
        action: Action.ENTR,
    };

    @dep public rate: number;
    @dep public direction = PresetSubtype.UnSupport;
    @dep public action = Action.ENTR;

    public forbidWebgl = true;
    public type = AnimFilters.BOUNCE;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super();
        const defaults = getDefaults<typeof BounceFilter>(this);
        this.rate = options.rate ?? defaults.rate;
        this.direction = options.direction ?? defaults.direction;
        this.action = options.action ?? defaults.action;
    }

    public apply(obj: DisplayObject, canvas: Canvas) {
        this.isEntr ? this.applyEntr(canvas) : this.applyExit(canvas);
    }

    protected applyEntr(canvas: Canvas) {
        const { width, height, x, y } = this.getCanvasInfo(canvas);
        // 入场使后部分 rate 都为 1，实现滤镜只有前部分才有效果，后半程不变
        let process = DEFAULT_DURATION / ENTR_FILTER_DURATION * this.rate;
        if (process >= 1) {
            process = 1;
        }
        const h = (1 - process) * height;
        canvas.clearRect(x, y, width, h);
    }

    protected applyExit(canvas: Canvas) {
        const { width, height, x, y } = this.getCanvasInfo(canvas);
        // 退场进度前半程始终为 1，使其不作用滤镜效果，后半程根据计算相对于退出滤镜时间的进度
        let process = 1;
        if (DEFAULT_DURATION * (1 - this.rate) <= EXIT_FILTER_DURATION) {
            process  = (DEFAULT_DURATION * (1 - this.rate)) / EXIT_FILTER_DURATION;
        }
        const offsetY = process * height;
        canvas.clearRect(x, offsetY, width, height);
    }

    protected getCanvasInfo(canvas: Canvas) {
        const { width, height, bounds } = canvas;
        const { x, y } = bounds;
        return { width, height, x, y };
    }

    protected get isEntr() {
        return this.action === Action.ENTR;
    }
}
